<template>
  <div class="modalContents__object07">
    <div class="container">
      <div class="row no-gutters">
        <div class="col-xl-5 col-lg-6 col-md-8 col-10 mx-auto">
          <h2 class="text-center">LOG IN</h2>

          <div class="row">
            <div class="col-sm-12">
              <div class="row no-gutters">
                <div class="col-sm-3 snsbtn">
                  <a href="/auth/line" class="btn text-center" style="background:#00c402;">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 448 512" style="enable-background:new 0 0 448 512;" xml:space="preserve"><path d="M272.1,204.2v71.1c0,1.8-1.4,3.2-3.2,3.2h-11.4c-1.1,0-2.1-0.6-2.6-1.3l-32.6-44v42.2c0,1.8-1.4,3.2-3.2,3.2h-11.4 c-1.8,0-3.2-1.4-3.2-3.2v-71.1c0-1.8,1.4-3.2,3.2-3.2H219c1,0,2.1,0.5,2.6,1.4l32.6,44v-42.2c0-1.8,1.4-3.2,3.2-3.2h11.4 C270.6,201,272.1,202.5,272.1,204.2L272.1,204.2z M190.1,201h-11.4c-1.8,0-3.2,1.4-3.2,3.2v71.1c0,1.8,1.4,3.2,3.2,3.2h11.4 c1.8,0,3.2-1.4,3.2-3.2v-71.1C193.3,202.5,191.9,201,190.1,201L190.1,201z M162.6,260.6h-31.1v-56.4c0-1.8-1.4-3.2-3.2-3.2h-11.4 c-1.8,0-3.2,1.4-3.2,3.2v71.1c0,0.9,0.3,1.6,0.9,2.2c0.6,0.5,1.3,0.9,2.2,0.9h45.7c1.8,0,3.2-1.4,3.2-3.2v-11.4 C165.7,262.1,164.3,260.6,162.6,260.6L162.6,260.6z M332.1,201h-45.7c-1.7,0-3.2,1.4-3.2,3.2v71.1c0,1.7,1.4,3.2,3.2,3.2h45.7 c1.8,0,3.2-1.4,3.2-3.2v-11.4c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8,0,3.2-1.4,3.2-3.2V234c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1 c1.8,0,3.2-1.4,3.2-3.2v-11.4C335.2,202.5,333.8,201,332.1,201L332.1,201z M448,113.7V399c-0.1,44.8-36.8,81.1-81.7,81H81 c-44.8-0.1-81.1-36.9-81-81.7V113c0.1-44.8,36.9-81.1,81.7-81H367C411.8,32.1,448.1,68.8,448,113.7z M386.4,236.3 c0-73-73.2-132.4-163.1-132.4S60.2,163.3,60.2,236.3c0,65.4,58,120.2,136.4,130.6c19.1,4.1,16.9,11.1,12.6,36.8 c-0.7,4.1-3.3,16.1,14.1,8.8c17.4-7.3,93.9-55.3,128.2-94.7C375.1,291.8,386.4,265.5,386.4,236.3z"/></svg>
                  <br>LINEログイン</a>
                </div>
                <div class="col-sm-3 snsbtn">
                  <a href="/auth/twitter" class="btn text-center" style="background: #1da1f2;">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/></svg>
                  <br>Twitterログイン</a>
                </div>
                <div class="col-sm-3 snsbtn">
                  <a href="/auth/facebook" class="btn text-center" style="background:#4267b2;">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 448 512" style="enable-background:new 0 0 448 512;" xml:space="preserve"><path d="M448,80v352c0,26.5-21.5,48-48,48h-85.3V302.8h60.6l8.7-67.6h-69.3V192c0-19.6,5.4-32.9,33.5-32.9H384V98.7 c-6.2-0.8-27.4-2.7-52.2-2.7c-51.6,0-87,31.5-87,89.4v49.9H184v67.6h60.9V480H48c-26.5,0-48-21.5-48-48V80c0-26.5,21.5-48,48-48h352 C426.5,32,448,53.5,448,80z"/>
                    </svg>
                  <br>Facebookログイン</a>
                </div>
                <div class="col-sm-3 snsbtn">
                  <a href="/auth/google" class="btn text-center">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 488 512" style="enable-background:new 0 0 488 512;" xml:space="preserve"><path d="M454.6,261c0,122.1-83.6,209.1-207.2,209.1C129,470.1,33.4,374.4,33.4,256S129,41.9,247.5,41.9c57.7,0,106.2,21.1,143.5,56 l-58.3,56c-76.2-73.5-218-18.3-218,102c0,74.7,59.6,135.2,132.7,135.2c84.8,0,116.5-60.8,121.5-92.3H247.5v-73.6h203.8 C453.2,236.2,454.6,246.8,454.6,261L454.6,261z"/></svg>
                  <br>Googleログイン</a>
                </div>
              </div>
            </div>
          </div>

          <div class="modalContents__object07--ex col-12 text-center">OR</div>

          <form method="post" action="/auth/login" class="row no-gutters">
            <input type="hidden" name="_token" :value='csrf_token'>
            <!-- エラーメッセージ -->
            <div class="col-12" v-if="login_error">
              <div class="alert alert-danger">ログイン情報が正しく有りません。</div>
            </div>
            <!-- メール -->
            <div class="col-12">
              <label for="bemailLogin">ログインID (メールアドレス or 電話番号)</label>
              <input
                type="text"
                name="accountLogin"
                id="bemailLogin"
                class="form-control"
                placeholder="LOGIN ID"
                required
              >
            </div>
            <!-- パスワード -->
            <div class="col-12">
              <label for="passwordLogin">パスワード</label>
              <input
                type="password"
                name="passwordLogin"
                id="passwordLogin"
                class="form-control"
                placeholder="パスワード（6〜12文字英数字）"
                required
              >
            </div>
            <!-- クッキー保存 -->
            <div class="col-12 form-check modalContents__object07--keep">
              <input type="checkbox" name="remember" id="keep" value="1">
              <label for="keep">ログイン状態を維持する</label>
            </div>
            <!-- ログインボタン -->
            <div class="col-12">
              <button class="text-center btn" type="submit">ログイン</button>
            </div>
          </form>
          <div class="modalContents__object07--forget">
            <a href="#" class="globalModal--btn" @click="showModalLostPassword">
              <i class="fa fa-unlock-alt" aria-hidden="true"></i>
              パスワードをお忘れの方は
            </a>
          </div>
          <div class="modalContents__object07__btn">
            <a href="javascript:void(0)" class="globalModal--btn" title="close" @click='hideModal'>
              <span class="fa-stack fa-lg">
                <i class="fa fa-circle-thin fa-stack-2x fa-inverse" aria-hidden="true"></i>
                <i class="fa fa-times fa-stack-1x fa-inverse" aria-hidden="true"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import MultiModalMixin from "../mixins/ModalMixin";

export default {
  name: "Login",
  mixins: [MultiModalMixin],
  data: function(){
    return {
      login_error:OPED.login_error,
      csrf_token:OPED.csrf_token,
    }
  },
  mounted : function(){
  }
};
</script>





// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/login.vue